import _ from 'lodash';

import utils from '@utils';

/**
 * 災害通知一覧ページネーション取得
 * @param qp 災害通知一覧ページネーションのクエリパラメータ
 */
export const paging = async (qp: NotificationsGetPagingQueryParams) => {
  // nullを渡すと期待通りの値が返ってこないため、キーそのものを渡さないようにする
  if (_.isNull(qp.prefecture)) {
    qp.prefecture = undefined;
  }
  if (_.isNull(qp.disasterType)) {
    qp.disasterType = undefined;
  }
  if (_.isNull(qp.fromSentDatetime)) {
    qp.fromSentDatetime = undefined;
  }
  if (_.isNull(qp.toSentDatetime)) {
    qp.toSentDatetime = undefined;
  }

  const res = await utils.axios
    .slsGo()
    .get('/notifications_paging', {params: qp});

  return res;
};

/**
 * 災害通知詳細ページネーション取得
 * @param qp 災害通知詳細ページネーションのクエリパラメータ
 */
export const detailPaging = async (qp: NotificationsGetDetailPagingParams) => {
  const res = await utils.axios
    .slsGo()
    .get('user_notifications_paging', {params: qp});

  return res;
};

/**
 * 災害通知詳細取得
 * @param qp 災害通知詳細取得のクエリパラメータ
 */
export const getOne = async (qp: NotificationGetOneQueryParams) => {
  const res = await utils.axios.slsGo().get(`/notifications`, {params: qp});

  return res;
};

/**
 * 災害通知送信
 * @param b 災害通知送信のbody
 */
export const create = async (b: NotificationCreateBody) => {
  const res = await utils.axios.slsGo().post('notifications_sending', b);

  return res.data;
};

/**
 * 安否回答送信
 * @param b 安否回答のbody
 */
export const answer = async (b: NotificationsUpdateBody) => {
  const res = await utils.axios.slsGo().put('user_notifications', b);

  return res;
};

export const getOneAnswer = async (id: string) => {
  const res = await utils.axios.slsGo().get(`user_notifications/${id}`);

  return res;
};

/**
 * サマリーされた安否確認状況を取得する
 * @param qp 安否確認状況取得のクエリパラメーター
 */

export const getSummary = async (qp: NotificationGetSummaryQueryParams) => {
  const res = await utils.axios
    .slsGo()
    .get('notifications_summary', {params: qp});

  return res;
};
